import { usePermissions } from '../hooks/usePermissions'
import TimetableManagement from './TimetableManagement'
import MyTimetable from './MyTimetable'

export default function Timetable() {
  const { hasCapability } = usePermissions()
  return hasCapability('access.timetable.manager_roles') ? <TimetableManagement /> : <MyTimetable />
}
